import { createContext } from 'react';

export const FloatingRootPortalContext = createContext<HTMLElement | null>(null);

/** Whether an action renders as an item of its group's floating menu, instead of as a button. */
export const FloatingMenuContext = createContext(false);
